<div class="menu-container" [class.lang-am]="currentLang === Language.HY">
  <div class="menu-toolbar mt-4 me-5 ms-3">
    <div class="menu-tabs">
      <button [class.active]="activeTab === 'all'" (click)="selectTab('all')">
        {{ 'menu_management.all_menus' | translate }}
      </button>
      <button [class.active]="activeTab === 'purchase-history'" (click)="selectTab('purchase-history')">
        {{ 'menu_management.purchase_history' | translate }}
      </button>
    </div>

    <div class="menu-search-filter-section">
      <div class="menu-search-bar">
        <mat-icon>search</mat-icon>
        <input type="text" [(ngModel)]="searchQuery" (input)="onSearch()" [placeholder]="'menu_management.search_placeholder' | translate"/>
        @if (searchQuery) {
          <mat-icon class="clear-search-icon" (click)="clearSearch()">close</mat-icon>
        }
      </div>
      <button class="menu-filter-button" [class.active-filter]="isFilterActive" (click)="openFilterDialog()">
        <mat-icon>filter_list</mat-icon>
        <span>{{ 'activity.filter' | translate }}</span>
        @if (isFilterActive) {
          <span class="filter-badge"></span>
        }
      </button>
    </div>

    @if (activeTab === 'all') {
      <button class="menu-add-new-button desktop-only" (click)="openCreateMenuDialog()">
        <mat-icon>add</mat-icon>
        <span>{{ 'menu_management.add_new_menu' | translate }}</span>
      </button>
    }
  </div>

  <mat-card class="menu-table-card mt-4 me-5 ms-3 custom-card">
    <mat-card-content>
    @if (activeTab === 'all') {
      @if (isLoading) {
        <div class="loading-container">
          <div class="spinner-border text-primary" role="status">
            <span class="visually-hidden">{{ 'common.loading' | translate }}</span>
          </div>
        </div>
      } @else if (menus.length === 0) {
        <div class="empty-state">
          <p>{{ 'menu_management.no_menu_found' | translate }}</p>
        </div>
      } @else {
        <div class="menu-table-wrap desktop-only">
          <div class="table-responsive">
            <table class="menu-table table mb-0 text-nowrap table-centered">
              <thead class="table-light">
              <tr>
                <th>#</th>
                <th>{{ 'menu_management.business_name' | translate }}</th>
                <th>{{ 'menu_management.menu_name' | translate }}</th>
                <th>{{ 'menu_management.address' | translate }}</th>
                <th class="menu-table-col-card-usernames">{{ 'menu_management.card_usernames' | translate }}</th>
                <th class="menu-table-action"></th>
              </tr>
              </thead>
              <tbody>
                @for (menu of menus; track menu.id; let index = $index) {
                  <tr>
                    <td>{{ (currentPage * pageSize) + index + 1 }}</td>
                    <td>{{ menu.business_name || '-' }}</td>
                    <td>{{ menu.menu_name }}</td>
                    <td>{{ menu.address || '-' }}</td>
                    <td class="menu-table-col-card-usernames">
                      @if (menu.linked_users && menu.linked_users.length > 0) {
                        <span class="card-usernames">
                          @for (username of menu.linked_users; track username; let isLast = $last) {
                            <a class="username-link" [routerLink]="['/', username]">{{ username }}</a>@if (!isLast) {
                              <span>, </span>
                            }
                          }
                        </span>
                      } @else {
                        <span>-</span>
                      }
                    </td>
                    <td class="menu-table-action">
                      <div class="action-buttons">
                        <a class="edit-menu-link" (click)="openEditMenuDialog(menu)">{{ 'menu_management.edit_menu' | translate }}</a>
                        <button class="grid-icon-btn" (click)="openQrModal(menu)" [title]="'menu_management.view_qr_code' | translate">
                          <img src="assets/menu/menu_qr_code.svg" alt="">
                        </button>
                        <button class="delete-btn" (click)="openDeleteDialog(menu)" [title]="'menu_management.delete_menu' | translate">
                          <mat-icon>close</mat-icon>
                        </button>
                      </div>
                    </td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        </div>

        <div class="menu-mobile-cards mobile-only">
          @for (menu of menus; track menu.id) {
            <div class="menu-mobile-card">
              <button
                type="button"
                class="menu-mobile-delete-btn"
                (click)="openDeleteDialog(menu)"
                [attr.aria-label]="'menu_management.delete_menu' | translate">
                <mat-icon>close</mat-icon>
              </button>

              <div class="mmc-field">
                <span class="mmc-label">{{ 'menu_management.menu_name' | translate }}</span>
                <span class="mmc-value">{{ menu.menu_name }}</span>
              </div>
              <div class="mmc-field">
                <span class="mmc-label">{{ 'menu_management.address' | translate }}</span>
                <span class="mmc-value">{{ menu.address || '-' }}</span>
              </div>

              <div class="menu-mobile-actions">
                <button type="button" class="menu-mobile-edit-btn" (click)="openEditMenuDialog(menu)">
                  {{ 'menu_management.edit_menu' | translate }}
                </button>
                <button
                  type="button"
                  class="menu-mobile-qr-btn"
                  (click)="openQrModal(menu)"
                  [attr.aria-label]="'menu_management.view_qr_code' | translate">
                  <img src="assets/menu/menu_qr_code.svg" alt="">
                </button>
              </div>
            </div>
          }
        </div>
      }
    } @else if (activeTab === 'purchase-history') {
      @if (isLoading) {
        <div class="loading-container">
          <div class="spinner-border text-primary" role="status">
            <span class="visually-hidden">{{ 'common.loading' | translate }}</span>
          </div>
        </div>
      } @else if (purchaseHistoryItems.length === 0) {
        <div class="empty-state">
          <p>{{ 'menu_management.no_purchase_history_found' | translate }}</p>
        </div>
      } @else {
        <div class="menu-table-wrap desktop-only">
          <div class="table-responsive">
            <table class="menu-table table mb-0 text-nowrap table-centered">
              <thead class="table-light">
              <tr>
                <th>#</th>
                <th>{{ 'menu_management.business_name' | translate }}</th>
                <th>{{ 'menu_management.menu_name' | translate }}</th>
                <th>{{ 'menu_management.address' | translate }}</th>
                <th>{{ 'menu_management.card_username' | translate }}</th>
                <th>{{ 'menu_management.date_time' | translate }}</th>
                <th>{{ 'menu_management.purchased_products' | translate }}</th>
                <th>{{ 'activity.amount' | translate }}</th>
                <th>{{ 'menu_management.type' | translate }}</th>
              </tr>
              </thead>
              <tbody>
                @for (item of purchaseHistoryItems; track item.id; let index = $index) {
                  <tr>
                    <td>{{ (purchaseHistoryPage * pageSize) + index + 1 }}</td>
                    <td>{{ item.businessName || '-' }}</td>
                    <td>{{ item.menuName }}</td>
                    <td>{{ item.address || '-' }}</td>
                    <td class="menu-table-col-card-usernames">{{ item.cardUsername || '-' }}</td>
                    <td>{{ item.purchaseDate | date:'dd/MM/yyyy HH:mm' }}</td>
                    <td class="menu-table-col-card-usernames">{{ item.purchasedProducts || '-' }}</td>
                    <td>{{ item.amount != null ? (item.amount | number:'1.2-2') : '-' }}</td>
                    <td>{{ item.type || '-' }}</td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        </div>

        <div class="menu-mobile-cards mobile-only">
          @for (item of purchaseHistoryItems; track item.id) {
            <div class="menu-mobile-card menu-mobile-card--history">
              <div class="mmc-field">
                <span class="mmc-label">{{ 'menu_management.menu_name' | translate }}</span>
                <span class="mmc-value">{{ item.menuName }}</span>
              </div>
              <div class="mmc-field">
                <span class="mmc-label">{{ 'menu_management.address' | translate }}</span>
                <span class="mmc-value">{{ item.address || '-' }}</span>
              </div>
              <div class="mmc-field">
                <span class="mmc-label">{{ 'menu_management.date_time' | translate }}</span>
                <span class="mmc-value">{{ item.purchaseDate | date:'dd.MM.yyyy / HH:mm' }}</span>
              </div>
              <div class="mmc-field">
                <span class="mmc-label">{{ 'menu_management.purchased_products' | translate }}</span>
                <span class="mmc-value">{{ formatPurchasedProductsDisplay(item.purchasedProducts) }}</span>
              </div>
              <div class="mmc-field">
                <span class="mmc-label">{{ 'activity.amount' | translate }}</span>
                <span class="mmc-value">
                  @if (item.amount != null) {
                    {{ item.amount | number:'1.0-0' }} ֏
                  } @else {
                    -
                  }
                </span>
              </div>
            </div>
          }
        </div>
      }
    }
    </mat-card-content>
  </mat-card>

  @if (activeTab === 'all' && totalPages > 1) {
    <div class="pagination">
      <a *ngFor="let page of getPageNumbers()"
         (click)="goToPage(page - 1)"
         [class.active]="currentPage === (page - 1)">
        {{ page }}
      </a>
    </div>
  }

  @if (activeTab === 'purchase-history' && purchaseHistoryTotalPages > 1) {
    <div class="pagination">
      <a *ngFor="let page of getPurchaseHistoryPageNumbers()"
         (click)="goToPurchaseHistoryPage(page - 1)"
         [class.active]="purchaseHistoryPage === (page - 1)">
        {{ page }}
      </a>
    </div>
  }

  <div class="common-footer menu-mobile-footer mobile-only">
    <button type="button" class="menu-mobile-add-btn" (click)="openCreateMenuDialog()">
      {{ 'menu_management.add_new_menu' | translate }}
    </button>
  </div>
</div>
